import { QRCodeCanvas } from 'qrcode.react';

export const QRCode = QRCodeCanvas;
